module.exports = __webpack_public_path__ + "img/st12.a34740b9.jpeg";